
export default bookFormule => {

  const bookSelect = bookFormule.querySelector('.dropdown-formules');
  const bookButton = bookFormule.querySelector('.button-label');

  bookSelect.addEventListener('change', (event) => {
    bookFormule.action = event.target.selectedOptions[0].dataset.url;
  });

};
